import DesignSystem from '@vcita/design-system';
import DesignSystemInit from '@vcita/design-system/init/DesignSystem';
import Vue from "vue";
import initI18n from "@vcita/design-system/init/initI18n";
import VcLayout from '@vcita/design-system/src/components/VcLayout/VcLayout.vue';
import VcLoader from '@vcita/design-system/src/components/VcLoader/VcLoader.vue';

const theme = {
  dark: false,
  options: {
    customProperties: true // allow create css variables based on the theme
  },
  themes: {
    light: {
      primary: '#0C315E',
      secondary: {
        base: '#0093B8',
        lighten1: '#99D4E3',
        lighten2: '#C2E5EE',
        lighten3: '#EDF7FA'
      },
      anchor: '#1155CC' // Defined as well as var(--link-color)
    }
  }
}

// These two components are being rendered before DS is ready, so adding them first
Vue.component('VcLayout', VcLayout);
Vue.component('VcLoader', VcLoader);

Vue.use(DesignSystem);

initI18n();

const config = {theme: {theme}};
export default DesignSystemInit(config);
